import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppUpdaterService } from '../../services/app-updater.service';

@Component({
    standalone: true,
    selector: 'app-update-notification',
    imports: [CommonModule],
    templateUrl: './update-notification.component.html',
    styleUrls: ['./update-notification.component.scss']
})
export class UpdateNotificationComponent implements OnInit {
    readonly updater = inject(AppUpdaterService);
    toastDismissed = false;
    readyDismissed = false;

    ngOnInit(): void {
        this.updater.init();
    }

    onDownload(): void {
        this.updater.downloadUpdate();
    }

    onInstall(): void {
        this.updater.installNow();
    }

    onLater(): void {
        // Dismiss whichever is currently showing
        if (this.updater.ready()) {
            this.readyDismissed = true;
        } else {
            this.toastDismissed = true;
        }
    }

    get showToast(): boolean {
        return !this.toastDismissed && this.updater.available() && !this.updater.downloading() && !this.updater.ready();
    }

    get showProgress(): boolean {
        return this.updater.downloading() && !this.updater.ready();
    }

    get showReady(): boolean {
        return !this.readyDismissed && this.updater.ready();
    }
}
